export const RESET_ERROR = 'RESET_ERROR';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_HISTORY_ERROR = 'CLEAR_HISTORY_ERROR';
